import { HomeOnlineExamNoDataScreen } from './HomeOnlineExamNoDataScreen';
export default HomeOnlineExamNoDataScreen;
